import React from 'react';

// An order's MOU column: units with the MOU given out of its units, as the order
// lists return it (`mou: { given, total }`). Green when every unit has it, amber
// for some, grey for none; "—" for an order with no units (or no data).
const MouCount: React.FC<{ mou?: { given?: number; total?: number } | null }> = ({ mou }) => {
    const total = mou?.total || 0;
    const given = mou?.given || 0;
    if (!total) return <span className="text-xs text-slate-400">—</span>;
    const [cls, title] = given >= total ? ['bg-emerald-50 text-emerald-800 ring-emerald-200', 'MOU given for every unit']
        : given ? ['bg-amber-50 text-amber-800 ring-amber-200', 'MOU given for some units']
        : ['bg-slate-100 text-slate-600 ring-slate-200', 'MOU not given yet'];
    return (
        <span title={title} className={`inline-flex items-center h-6 px-2.5 rounded-full ring-1 text-[11px] font-bold tabular-nums whitespace-nowrap ${cls}`}>
            {given}/{total}
        </span>
    );
};

export default MouCount;
